// @internal
import styled, { css } from 'styled-components';
import { OutlineStyles, StyledSideNavProps } from '../../styles';
import { SideNavGroupToggleProps } from '../../SideNav';
import { sidenavTokens } from '../../../../tokens/components/SideNav/tokens';

type StyledSideNavGroupToggleProps = Pick<SideNavGroupToggleProps, 'alwaysShowMenuItems'> &
  Pick<StyledSideNavProps, 'isClosed'>;

export const StyledSideNavGroupToggle = styled.button<StyledSideNavGroupToggleProps>`
  align-items: center;
  background-color: transparent;
  border: none;
  border-radius: ${sidenavTokens.GroupToggleBorderRadiusBaseDefault};
  color: ${sidenavTokens.FontColorBaseDefault};
  display: flex;
  font-weight: ${sidenavTokens.GroupToggleFontWeightBaseDefault};
  line-height: ${sidenavTokens.GroupToggleFontLeadingBaseDefault};
  height: auto;
  justify-content: space-between;
  margin: 0 ${sidenavTokens.GroupToggleMarginBaseOpenHorizontal};
  padding: ${sidenavTokens.GroupTogglePaddingBaseOpen};
  transition: background-color ${sidenavTokens.TransitionDurationBaseDefault}
    ${sidenavTokens.TransitionCurveBaseDefault};
  width: 100%;

  &:hover {
    cursor: pointer;
  }

  ${OutlineStyles}

  ${({ isClosed }) =>
    isClosed &&
    css`
      display: block;
      justify-content: center;
      margin: ${sidenavTokens.GroupToggleMarginBaseClosedVertical}
        ${sidenavTokens.GroupToggleMarginBaseClosedHorizontal};
      padding: ${sidenavTokens.GroupTogglePaddingBaseClosed};

      &:hover {
        background-color: ${sidenavTokens.GroupToggleBackgroundColorBaseHover};
      }
    `}
`;

type StyledSideNavGroupToggleLabelProps = Pick<StyledSideNavProps, 'isClosed'>;

export const StyledSideNavGroupToggleLabel = styled.span<StyledSideNavGroupToggleLabelProps>`
  flex-grow: 1;
  flex-shrink: 0;
  line-height: 20px;

  ${({ isClosed }) =>
    isClosed &&
    css`
      display: none;
      width: 0;
    `}
`;
